import axios from '@/lib/AxApi';

export default {
    async selectRow(params)
    {
        try
        {
            const response = await axios.post('/UserInvoices/selectRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },

    async insertRow(params)
    {
        try
        {
            const response = await axios.post('/UserInvoices/insertRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },

    async updateRow(params)
    {
        try
        {
            const response = await axios.post('/UserInvoices/updateRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },

    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/UserInvoices/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },

    async selectUserInvoices(params)
    {
        try
        {
            const response = await axios.post('/UserInvoices/selectUserInvoices', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
};
